import React, { useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import LeadsContext from '@/modules/leads/contexts/LeadsContext';
import { humanizeNumber } from '~/common';

const TitleAffiliate = () => {
    const leadsContext = useContext(LeadsContext);
    const count = leadsContext.count;

    return (
        <Typography>{humanizeNumber(count.count)} из {humanizeNumber(count.total)}</Typography>
    );
};

export default TitleAffiliate;
